import { useEvidencePermission } from '@utils/permission-hook';
import React from 'react';
import { useIntl } from 'react-intl';
import { AuthoredEvidence, Evidence } from '@eas/common-web';
import { ResearchQuery } from '@models';
import { useColumns } from './research-query-columns';
import { Fields } from './research-query-fields';
import { useValidationSchema } from './research-query-schema';
import { EvidenceApiUrl, ExportTag, Permission } from '@enums';

export function ResearchQueries() {
  const intl = useIntl();

  const validationSchema = useValidationSchema();

  const permissions = useEvidencePermission({
    options: {
      NEW: [],
      EDIT: [],
      REMOVE: [Permission.Default.ADMINISTRATOR],
      REFRESH: [Permission.Default.ADMINISTRATOR],
      SHARE: [Permission.Default.ADMINISTRATOR],
      CHECK: [],
      SAVE: [],
      CLOSE: [],
    },
  });

  const evidence = AuthoredEvidence.useAuthoredEvidence<ResearchQuery>({
    version: 3,
    identifier: 'RESEARCH_QUERIES',
    apiProps: {
      url: EvidenceApiUrl.RESEARCH_QUERY,
    },
    tableProps: {
      columns: useColumns(),
      tableName: intl.formatMessage({
        id: 'TAPIS__RESEARCH_QUERIES__TABLE__TITLE',
        defaultMessage: 'Přehled záznamů dotazů',
      }),
      reportTag: ExportTag.RESEARCH_QUERY_GRID,
    },
    detailProps: {
      FieldsComponent: Fields,
      validationSchema,
      toolbarProps: {
        title: intl.formatMessage({
          id: 'TAPIS__RESEARCH_QUERIES__DETAIL__TITLE',
          defaultMessage: 'Přehled záznamů dotazů',
        }),
        showBtn: permissions,
      },
    },
  });

  return <Evidence {...evidence} />;
}
